import request from '@/utils/request';

// 查询手机号码是否已注册
export function isRegisterPhone(options) {
  return request({
    url: `/op/statistical/isRegisterPhone/${options.phone}`,
    method: 'get'
  });
}

// 更换账号手机号
export function updateUserPhone(options) {
  return request({
    url: `/op/statistical/UpdateUserPhone`,
    method: 'post',
    data: options
  });
}

// 发送修改手机号的验证码
export function sendUpdatePhoneSms(options) {
  return request({
    url: `/op/statistical/sendUpdatePhoneSms/${options.phone}`,
    method: 'get'
  });
}

// 解绑设备
export function unbindingDevice(deviceNo) {
  return request({
    url: `/device/lotdetails/deskDeviceUnbind?deviceNo=${deviceNo}`,
    method: 'post'
  });
}

// 设备绑定
export function bindingsDevice(data) {
  return request({
    url: `/device/bind/batch/device`,
    method: 'post',
    data: data
  });
}

// 查询设备绑定分页列表
export function getDeviceBindings(options) {
  return request({
    url: `/op/statistical/device/bindings/page`,
    method: 'get',
    params: options
  });
}

// 新建设备绑定批次
export function bindBatch(options) {
  return request({
    url: `/device/bind/batch`,
    method: 'post',
    data: options
  });
}

// 查询设备绑定批次分页列表
export function getBindBatchPage(options) {
  return request({
    url: `/device/bind/batch/page`,
    method: 'get',
    params: options
  });
}

// 删除设备绑定批次
export function deleteBatchDetail(batchId) {
  return request({
    url: `/device/bind/batch/${batchId}`,
    method: 'delete'
  });
}

// 查询设备绑定分页列表
export function getBindDevicePage(options) {
  return request({
    url: `/device/bind/batch/device/page`,
    method: 'get',
    params: options
  });
}

// 修改设备版本
export function updateDeviceVersion(op) {
  return request({
    url: `/device/bind/batch/device`,
    method: 'put',
    data: op
  });
}

// 修改设备绑定批次
export function updateDeviceBatchInfo(op) {
  return request({
    url: `/device/bind/batch`,
    method: 'put',
    data: op
  });
}

// 查询批次绑定手机号列表
export function getBatchPhoneList(op) {
  return request({
    url: `/device/bind/batch/phones`,
    method: 'get',
    params: op
  });
}

// 转移设备绑定
export function transferDeviceBatch(op) {
  return request({
    url: `/device/bind/batch/device/transfer`,
    method: 'put',
    data: op
  });
}

// 删除设备
// export function deleteDeviceBatch(batchId) {
//   return request({
//     url: `/device/bind/batch/${batchId}`,
//     method: 'delete'
//   });
// }

// 查询转移设备绑定批次分页列表
export function getBindBatchChangePage(options) {
  return request({
    url: `/device/bind/batch/change/page`,
    method: 'get',
    params: options
  });
}
